import { cicFeeReasonsApi, cicFeeReasonsApiV2, expressionDefinitionApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CIC_FEE_REASONS_ACTION_TYPE = createNamedActions('cicFeeReasons', {
  GET_FEE_REASONS: 'GET_FEE_REASONS',
  CREATE_FEE_REASON: 'CREATE_FEE_REASON',
  EDIT_FEE_REASON: 'EDIT_FEE_REASON',
  DELETE_FEE_REASON: 'DELETE_FEE_REASON',
  GET_CIC_REASONS_SCHEMA: 'GET_CIC_REASONS_SCHEMA',
});

const cicFeeReasonsSchema = new schema.Entity('data', {}, { idAttribute: 'cicFeeReasonId' });

export const getCicFeeReasonsFilteredAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await cicFeeReasonsApi.getCicFeeReasonsFiltered(params);

  return dispatch({
    type: CIC_FEE_REASONS_ACTION_TYPE.GET_FEE_REASONS,
    payload: normalize(data, [cicFeeReasonsSchema]).entities.data,
  });
});

export const getCicFeeReasonsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await cicFeeReasonsApiV2.getCicFeeReasons(params);

  return dispatch({
    type: CIC_FEE_REASONS_ACTION_TYPE.GET_FEE_REASONS,
    payload: normalize(data, [cicFeeReasonsSchema]).entities.data,
  });
});

export const getActiveCicFeeReasonsAction = catchAsyncActionError(() => async () => {
  const { data } = await cicFeeReasonsApiV2.getActiveCicFeeReasons();

  return data ?? [];
});

export const createCicFeeReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await cicFeeReasonsApiV2.createCicFeeReasons(params);

  return dispatch({
    type: CIC_FEE_REASONS_ACTION_TYPE.CREATE_FEE_REASON,
    payload: data,
  });
});

export const editCicFeeReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await cicFeeReasonsApiV2.editCicFeeReasons(params);

  return dispatch({
    type: CIC_FEE_REASONS_ACTION_TYPE.EDIT_FEE_REASON,
    payload: data,
  });
});

export const deleteCicFeeReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await cicFeeReasonsApiV2.deleteCicFeeReasons(params);

  return dispatch({
    type: CIC_FEE_REASONS_ACTION_TYPE.DELETE_FEE_REASON,
    payload: data,
    meta: params,
  });
});

export const getCICReasonsSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApi.getCICFeeReasonExpressionDefinition();

  return dispatch({
    type: CIC_FEE_REASONS_ACTION_TYPE.GET_CIC_REASONS_SCHEMA,
    payload: data,
  });
});
